<template>
  <div class="members-introduce">
    <Empty v-if="isEmpty(data)" class="no-data"></Empty>
    <div v-else>
      <div class="public-sty" :class="className" >
        <ul>
          <li v-for="(member, index) in data.slice((currentPage-1)*pageSize,currentPage*pageSize)" :key="index">
            <div class="list-title">
              <img v-if="member.logo" :src="member.logo" alt="" />
              <span v-else>{{ member.enterprise_name }}</span>
            </div>
            <div class="content">
              <p style="white-space: pre-wrap;">{{member.description}}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="members-introduce-page">
        <el-pagination
          v-if="data.length > pageSize"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Empty from '@/components/empty.vue';
import { isEmpty } from 'lodash';
export default {
  name: 'member-list',
  components: {
    Empty
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: 2
    },
    total: {
      type: Number,
      default: 0
    },
    className: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentPage: 1
    };
  },
  methods: {
    isEmpty,
    handleCurrentChange (val) {
      this.currentPage = val;
    }
  }
};
</script>

<style scoped lang="scss">
.members-introduce {
  .no-data{
    padding-top: 20px;
  }
  &-page {
    height: 32px;
    text-align: right;
    margin-top: 10px;
  }
  .public-sty {
    overflow: hidden;
    .list-title {
      border-bottom: 1px solid #ccc;
      padding-bottom: 20px;
      img{
        width: 160px;
        height: 48px;
      }
    }
    .content {
      margin: 32px auto;
      overflow: auto;
      padding: 0 10px;
      p {
        font-size: 12px;
        color: #666666;
        letter-spacing: -0.5px;
        text-align: justify;
        line-height: 26px;
      }
    }
    ul {
      margin: 40px -50px 0 0;
    }
    li {
      float: left;
      background: #ffffff;
      padding: 10px;
      margin-right: 48px;
    }
  }
  .special {
    .list-title {
      border-bottom: none;
      padding-bottom: 0;
      height: 90px;
      background: rgba(255, 245, 212, 0.5);
      line-height: 118px;
    }
    .content {
      width: 512px;
      height: 336px;
    }
    ul {
      height: 500px;
    }
    li {
      width: 576px;
      height: 500px;
      border: 2px solid #d8b84e;
    }
  }
  .director {
    .content {
      width: 512px;
      height: 236px;
    }
    li {
      width: 576px;
      height: 400px;
      border: 1px solid #cccccc;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);
      border-top: 4px solid #0c63d7;
    }
  }
  .common {
    height: 880px;
    .content {
      width: 304px;
      height: 226px;
    }
    li {
      width: 368px;
      height: 400px;
      padding: 32px;
      margin-bottom: 40px;
      border: 1px solid #cccccc;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);
      border-top: 4px solid #0c63d7;
    }
  }

  .content::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 8px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
    left: 10px;
  }
  .content::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    // border-radius: 4px;
    // // box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    // background   : #000000;
    opacity: 0.2;
    background: #cccccc;
    border-radius: 4px;
    border-radius: 4px;
  }
  .content::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    // box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    // border-radius: 10px;
    // background   : #ededed;
    background: transparent;
  }
}
::v-deep {
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    background: #fff;
    border: 1px solid rgba(204,204,204,1);
    border-radius: 3px;
  }
}
</style>
